interface ViewAllBaseProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  headerClass?: string;
  onGoBack: () => void;
}

const ViewAllBaseComp = (props: ViewAllBaseProps) => {
  const { title, icon, children, headerClass = "", onGoBack } = props;
  return (
    <div className="view-all-page">
      <header className={`view-all-header ${headerClass}`}>
        <button className="back-btn" onClick={() => onGoBack()}>
          ←
        </button>
        <h1>
          {icon && <span className="icon">{icon}</span>}
          {title}
        </h1>
      </header>

      {children}
    </div>
  );
};

export default ViewAllBaseComp;
